/* SISTEMA PULSO — cargador reparador de baterias 12V */
(function(){
  'use strict';

  /* ---------- galeria ---------- */
  function galeria(){
    var foto = document.getElementById('pulsoGalFoto');
    if(!foto) return;
    document.querySelectorAll('.gal__t').forEach(function(t){
      t.addEventListener('click', function(){
        document.querySelectorAll('.gal__t').forEach(function(o){ o.classList.remove('on'); });
        t.classList.add('on');
        var img = t.querySelector('img');
        if(!img) return;
        foto.src = img.currentSrc || img.src;
        if(img.getAttribute('srcset')) foto.srcset = img.getAttribute('srcset');
        foto.alt = t.getAttribute('aria-label') || '';
        foto.classList.toggle('contexto', t.dataset.modo === 'cover');
      });
    });
  }

  /* ---------- diagnostico: el voltaje sube al entrar en pantalla ---------- */
  function diagnostico(){
    var caja = document.querySelector('.diag');
    if(!caja) return;
    var num  = caja.querySelector('[data-diag-num]');
    var est  = caja.querySelector('[data-diag-estado]');
    var segs = caja.querySelectorAll('.diag__seg');
    if(!num) return;

    var ini = parseFloat(caja.dataset.desde) || 11.4;
    var fin = parseFloat(caja.dataset.hasta) || 13.8;
    var dur = parseInt(caja.dataset.duracion, 10) || 2600;
    var t1 = caja.dataset.paso1 || 'Diagnosticando...';
    var t2 = caja.dataset.paso2 || 'Reparando por pulso...';
    var t3 = caja.dataset.paso3 || 'Recuperada - 100%';
    var corrio = false;

    function anima(){
      if(corrio) return; corrio = true;
      var t0 = null;
      function paso(t){
        if(!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);              /* ease-out */
        num.textContent = (ini + (fin - ini) * e).toFixed(1);
        var n = Math.round(e * segs.length);
        segs.forEach(function(s, i){ s.classList.toggle('on', i < n); });
        if(est) est.textContent = p < .34 ? t1 : (p < .72 ? t2 : t3);
        if(p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      num.textContent = fin.toFixed(1);
      segs.forEach(function(s){ s.classList.add('on'); });
      if(est) est.textContent = t3;
      return;
    }
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        en.forEach(function(x){ if(x.isIntersecting) anima(); });
      }, { threshold:.35 }).observe(caja);
    } else { anima(); }
  }

  /* ---------- packs: eligen la variante real de Shopify ---------- */
  function packs(){
    var lista = document.querySelectorAll('.pack');
    if(!lista.length) return;
    var campo = document.querySelector('[data-pulso-variante]');

    function pinta(p){
      lista.forEach(function(o){ o.classList.remove('on'); });
      p.classList.add('on');
      if(campo && p.dataset.variante) campo.value = p.dataset.variante;

      var pr  = p.querySelector('.pack__pr b');
      var tit = p.querySelector('.pack__t');
      var bp  = document.querySelector('[data-barra-precio]');
      var bt  = document.querySelector('[data-barra-texto]');
      if(bp && pr)  bp.textContent = pr.textContent;
      if(bt && tit) bt.textContent = tit.textContent + ' - pagas al recibir';

      /* que la URL lleve la variante, para compartir y para Releasit */
      if(p.dataset.variante && window.history && history.replaceState){
        var u = new URL(window.location.href);
        u.searchParams.set('variant', p.dataset.variante);
        history.replaceState({}, '', u);
      }
    }

    lista.forEach(function(p){
      p.addEventListener('click', function(){ pinta(p); });
      p.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); pinta(p); }
      });
    });

    /* si la URL ya trae ?variant=, respetarla */
    var pedida = new URLSearchParams(window.location.search).get('variant');
    if(pedida){
      var encontrada = [].slice.call(lista).filter(function(p){ return p.dataset.variante === pedida; })[0];
      if(encontrada) pinta(encontrada);
    }
  }

  /* ---------- faq ---------- */
  function faq(){
    document.querySelectorAll('.faq__b').forEach(function(b){
      b.addEventListener('click', function(){
        var i = b.parentElement;
        var abierto = i.classList.toggle('abierto');
        b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  /* ---------- barra fija ----------
     Con listener de scroll y no IntersectionObserver: si el visitante salta
     el bloque de golpe nunca cruza el umbral y la barra no aparece jamas. */
  function barra(){
    var b = document.querySelector('.pulso-barra');
    if(!b) return;
    var desde = parseInt(b.dataset.desde, 10) || 640;
    var pendiente = false;
    function revisa(){
      b.classList.toggle('ver', window.scrollY > desde);
      pendiente = false;
    }
    window.addEventListener('scroll', function(){
      if(!pendiente){ requestAnimationFrame(revisa); pendiente = true; }
    }, { passive:true });
    revisa();
  }

  /* ---------- reloj de oferta por visitante ---------- */
  function reloj(){
    var el = document.querySelector('[data-pulso-reloj]');
    if(!el) return;
    var horas = parseFloat(el.dataset.horas) || 2;
    var clave = 'pulso_oferta_limite';
    var lim = parseInt(localStorage.getItem(clave) || '0', 10);
    if(!lim || lim < Date.now()) lim = Date.now() + horas * 3600 * 1000;
    try { localStorage.setItem(clave, lim); } catch(e){}

    function dd(n){ return n < 10 ? '0' + n : '' + n; }
    function tic(){
      var s = Math.max(0, Math.floor((lim - Date.now()) / 1000));
      var d = Math.floor(s / 86400);
      var h = Math.floor(s % 86400 / 3600);
      el.textContent = (d ? d + 'd ' : '') + dd(h) + ':' + dd(Math.floor(s % 3600 / 60)) + ':' + dd(s % 60);
    }
    tic();
    setInterval(tic, 1000);
  }

  function arranca(){ galeria(); diagnostico(); packs(); faq(); barra(); reloj(); }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', arranca);
  } else { arranca(); }

  /* el editor de Shopify recarga secciones sueltas */
  document.addEventListener('shopify:section:load', arranca);
})();